import {DopamineAnswer, DopamineRunEvent} from './DopamineAssistant.types'

export const createDopamineAnswer = (): DopamineAnswer => ({
  markdown: '',
  messageId: null,
  runId: null,
  status: 'idle',
})

export const updateDopamineAnswer = (
  state: DopamineAnswer,
  event: DopamineRunEvent,
): DopamineAnswer => {
  if (event.type === 'RUN_STARTED') {
    return {...createDopamineAnswer(), runId: event.runId}
  }

  if (event.type === 'RUN_ERROR' && state.status === 'idle') {
    return {...state, runId: event.runId, status: 'failed'}
  }

  if (
    event.runId !== state.runId ||
    state.status === 'failed' ||
    state.status === 'completed'
  )
    return state

  switch (event.type) {
    case 'TEXT_MESSAGE_START':
      return {
        ...state,
        markdown: '',
        messageId: event.messageId,
        status: 'streaming',
      }
    case 'TEXT_MESSAGE_CONTENT':
      if (state.status !== 'streaming' || event.messageId !== state.messageId) {
        return state
      }
      return {...state, markdown: `${state.markdown}${event.delta}`}
    case 'TEXT_MESSAGE_END':
      if (state.status !== 'streaming' || event.messageId !== state.messageId) {
        return state
      }
      return {...state, status: 'awaiting-finish'}
    case 'RUN_FINISHED':
      return {...state, status: 'completed'}
    case 'RUN_ERROR':
      return {...state, status: 'failed'}
    default:
      return state
  }
}
